import { Component, OnInit } from '@angular/core';
import { UpdateFormDataActionWithId } from '@app/finxone-web-frontend/app/lib/actions/form-submission.action';
import {
  OrganisationState,
  OrganisationStateModel,
} from '@app/finxone-web-frontend/app/lib/state/organisation.state';
import { FormActionTypeEnum } from '@finxone-platform/form-action';
import { Select, Store } from '@ngxs/store';
import { map, Observable, takeUntil } from 'rxjs';
import { FormSubmitter } from '../form-widgets/form-submitter/form-submitter.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-edit-org-registration-number-widget',
  templateUrl: './edit-org-registration-number-widget.component.html',
})
export class EditOrgRegistrationNumberWidgetComponent extends FormSubmitter implements OnInit {
  @Select(OrganisationState.getOrganisation)
  public organisation$: Observable<OrganisationStateModel>;
  public registrationNumber: string;
  public formActionData: string;

  constructor(protected override store: Store) {
    super(store);
  }

  ngOnInit() {
    this.getFormActionDataWithId(FormActionTypeEnum.KYB_DETAILS)
      .pipe(
        takeUntil(this.destroy$),
        map((formActionData) => {
          this.formActionData = formActionData?.['formData'].identificationNumber;
          if (formActionData?.['formData'].identificationNumber) {
            this.registrationNumber = formActionData?.['formData'].identificationNumber;
          }
        }),
      )
      .subscribe();
    this.organisation$.pipe(takeUntil(this.destroy$)).subscribe((organisation) => {
      if (!this.formActionData) this.registrationNumber = organisation.identificationNumber;
    });
  }

  public valueChanges(registrationNumber: string) {
    this.store.dispatch(
      new UpdateFormDataActionWithId(
        {
          identificationNumber: registrationNumber,
        },
        FormActionTypeEnum.KYB_DETAILS,
      ),
    );
  }
}
